import { validateEmail } from '../models/email';
import { authentificationRepository } from '../repositories/authentication-repository';

async function requestToMagicLink({email}) {
    const validationData = validateEmail(email);

    if (!validationData.isValid) {
        throw Error(validationData.message);
    }

    const data = await authentificationRepository.requestToMagicLink({email});

    return data;
};

export {
    requestToMagicLink
};
